export enum ApiMessageType {
    /// <summary>
    /// Informational message.
    /// </summary>
    Info = 0,
    /// <summary>
    /// Successful message.
    /// </summary>
    Successful = 1,
    /// <summary>
    /// Warning message.
    /// </summary>
    Warning = 2,
    /// <summary>
    /// Error message.
    /// </summary>
    Error = 3
}